/*
 *  Copyright (C) 2023 Atelier Cartographique <contact@atelier-cartographique.be>
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, version 3 of the License.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { Option } from 'fp-ts/lib/Option';
import { scopeOption } from 'sdi/lib';
import { IViewEvent } from 'sdi/map';
import { queryK } from 'sdi/shape/functions';
import { tryNumber } from 'sdi/util';

// Very simple route mod

const getRoute = queryK('app/route');

export type EmbedRoute = { mapId: string; view: Option<IViewEvent> };

export const parseArgs = (args: readonly string[]): EmbedRoute => ({
    mapId: args[0],
    view: scopeOption()
        .let('lat', tryNumber(args[1]))
        .let('lon', tryNumber(args[2]))
        .let('zoom', tryNumber(args[3]))
        .map(({ lat, lon, zoom }) => ({
            dirty: 'geo' as const,
            zoom,
            center: [lat, lon],
        })),
});

export const parseRoute = () => parseArgs(getRoute());
